import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ApiHandlerDiscreteParameter, HasOnError } from "@insite/client-framework/HandlerCreator";
import { Cart, CartResult, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    SendTracking,
    SetCartStatus,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { trackCompletedOrder } from "@tsesco/Custom/Utilities/tracking";
import cloneDeep from "lodash/cloneDeep";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

interface PlaceOrderParameter {
    paymentMethod: string;
    poNumber: string;
    vatNumber?: string;
    saveCard: boolean;
    cardHolderName: string;
    cardNumber: string;
    cardType: string;
    expirationMonth: number;
    expirationYear: number;
    securityCode: string;
    useBillingAddress: boolean;
    address1: string;
    countryId: string;
    stateId: string;
    city: string;
    postalCode: string;
    onSuccess?: (cartId: string) => void;
    payPalToken?: string;
    payPalPayerId?: string;
    isPending?: boolean;
    isAdyenDropIn?: boolean;
    adyenPspReference?: string;
    accountHolderName?: string;
    accountNumber?: string;
    routingNumber?: string;
}

type HandlerType = ApiHandlerDiscreteParameter<
    PlaceOrderParameter & HasOnError,
    UpdateCartApiParameter,
    CartResult,
    {
        cartToUpdate: Cart;
    }
>;

export let transactionCompleted = false;

replaceInChain(chain, SetCartStatus, props => {
    const state = props.getState();
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const { editedCartNotes } = state.pages.checkoutShipping;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;

    if (!cart) {
        throw new Error("There was no current cart and we are trying to place the current cart as an order.");
    }
    const notes = typeof editedCartNotes === "undefined" ? cart.notes : editedCartNotes;

    const newStatus = cart?.requiresApproval
        ? "AwaitingApproval"
        : props.parameter?.isPending
        ? "PendingPaymentValidation"
        : "Submitted";

    props.cartToUpdate = {
        ...cloneDeep(cart),
        notes,
        status: newStatus,
        poNumber: props.parameter.poNumber,
        customerVatNumber: props.parameter.vatNumber || "",
    };
    if ((props.parameter as unknown as any).properties?.shipViaAccountNumber) {
        props.cartToUpdate.properties.shipViaAccountNumber = (
            props.parameter as unknown as any
        ).properties?.shipViaAccountNumber;
    }
    if (!cart?.properties?.shipViaCollect) {
        props.cartToUpdate.properties.shipViaAccountNumber = ("" as unknown as any).properties?.shipViaAccountNumber;
    }
});

function markTransactionCompleted() {
    transactionCompleted = true;
}

export const SendCustomTracking: HandlerType = props => {
    // trackCompletedOrder(props.cartToUpdate, props.apiResult.cart.erpOrderNumber, props.apiResult.billTo);
    // trackCompletedOrder(props.cartToUpdate, props.apiResult.billTo);
    markTransactionCompleted();
};

replaceInChain(chain, SendTracking, SendCustomTracking);
